import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./SubscriptionPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
// import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import TermsModal from '../components/TermsModal';
import { login, sendOtpApi, subscribeApi } from '../http/http';

const SubscriptionPage = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [terms, setTerms] = useState(false);

    const [pack, setPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            if (!terms) {
                toast.info(t("130"));
                return;
            }
            setLoading(true);

            let msisdnWithCountryCode = msisdn;

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('257')) {
                msisdnWithCountryCode = '257' + msisdnWithCountryCode;
            }

            // const response = await subscribeApi(msisdn, pack, extRef);
            const response = await sendOtpApi(msisdnWithCountryCode);
            console.log(response, 'response...');
            setLoading(false);
            if (response?.data?.status == 1) {
                navigate("/otp", {
                    state: {
                        msisdn: msisdnWithCountryCode,
                        extRef: extRef
                    }
                })
            }
            else {
                toast.error(t("87"));
            }

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                // toast.error(t("126"));
                toast.info(t("94"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("87"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    // const handleFormSubmission = async (e) => {
    //     try {
    //         e.preventDefault();
    //         setLoading(true);

    //         let msisdnWithCountryCode = msisdn;

    //         if (msisdnWithCountryCode.startsWith('0')) {
    //             msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
    //         }

    //         if (!msisdnWithCountryCode.startsWith('257')) {
    //             msisdnWithCountryCode = '257' + msisdnWithCountryCode;
    //         }

    //         const response = await subscribeApi(msisdnWithCountryCode, extRef);
    //         setLoading(false);

    //         if (response?.data?.status == 1) {
    //             toast.success(t("90"));

    //             await login({ msisdn: msisdnWithCountryCode })
    //                 .then((res) => {
    //                     setLoading(false);
    //                     dispatch(setUserToken(res?.data?.result?.token));
    //                     navigate("/home", { replace: true, state: null });
    //                     toast.success(t("84"));
    //                 })
    //                 .catch((err) => {
    //                     setLoading(false);
    //                     if (err?.response?.data?.error?.status == 1) {
    //                         navigate("/low-balance");
    //                     }
    //                     else {
    //                         toast.error(t("92"));
    //                     }
    //                 });
    //         }

    //         if (response?.data?.status == 2) {
    //             toast.success(t("91"));
    //             navigate("/low-balance");
    //         }

    //     } catch (error) {
    //         setLoading(false);
    //         if (error?.response?.data?.status == 0) {
    //             toast.error(t("93"));
    //         }
    //         else if (error?.response?.data?.status == 1) {
    //             toast.error(t("94"));
    //         }
    //         else {
    //             toast.error(t("86"));
    //         }
    //     }
    // }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <h1 className={classes.heading}>
                    <span style={{ color: '#3550dc' }}>Quiz Masters</span>{" "}{t("59")}
                </h1>
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box}`}
                            type='button'
                            onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("61")}
                        </button>
                    </div>
                </div>


                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/burundi.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+257</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                            onClick={() => setPack("Daily")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_blue}`}>{t("119")}</span>
                            {
                                pack === "Daily" ?
                                    <div className={`${classes.checked_radio} ${pack === "Daily" && classes.shade_blue}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                {t("127")}{" "}/{" "}
                                {t("128")}
                            </p>
                        </button>

                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked={terms} onChange={(e) => {

                                setTerms(e.target.checked)
                            }}
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("99")}{" "}<span className={classes.link} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setTermsModal(true)
                            }}>{t("114")}</span>
                        </label>
                    </div>

                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
        </>
    )
}

export default SubscriptionPage